import { Link, usePage } from "@inertiajs/react"
import {
  Calculator,
  ClipboardList,
  FileSpreadsheet,
  LayoutGrid,
  Receipt,
  Tag,
  Upload,
} from "lucide-react"

import { NavFooter } from "@/components/nav-footer"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  categoriesPath,
  dashboardPath,
  entriesPath,
  newCsvImportPath,
  profitLossPath,
  scheduleCPath,
  taxEstimatePath,
} from "@/routes"
import type { NavItem } from "@/types"

import AppLogo from "./app-logo"

function useMainNavItems(): NavItem[] {
  const { needs_review_count } = usePage().props as {
    needs_review_count: number
  }

  return [
    {
      title: "Dashboard",
      href: dashboardPath(),
      icon: LayoutGrid,
    },
    {
      title: "Entries",
      href: entriesPath(),
      icon: Receipt,
      badge: needs_review_count,
    },
    {
      title: "Categories",
      href: categoriesPath(),
      icon: Tag,
    },
    {
      title: "Import CSV",
      href: newCsvImportPath(),
      icon: Upload,
    },
    {
      title: "P&L Report",
      href: profitLossPath(),
      icon: FileSpreadsheet,
    },
    {
      title: "Schedule C Worksheet",
      href: scheduleCPath(),
      icon: ClipboardList,
    },
    {
      title: "Tax Estimates",
      href: taxEstimatePath(),
      icon: Calculator,
    },
  ]
}

const footerNavItems: NavItem[] = []

export function AppSidebar() {
  const mainNavItems = useMainNavItems()

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
      </SidebarContent>

      <SidebarFooter>
        <NavFooter items={footerNavItems} className="mt-auto" />
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
